var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditorInput',{attrs:{"class_style":_vm.class_style,"placeholder":_vm.placeholder,"id":_vm.id,"disabled":_vm.disabled,"prop_text":_vm.text},on:{"onChangeContent":(content) => _vm.text = content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }